import { render, staticRenderFns } from "./CoventryAlerts.vue?vue&type=template&id=4b603b71&"
import script from "./CoventryAlerts.vue?vue&type=script&lang=js&"
export * from "./CoventryAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports